import { render, staticRenderFns } from "./KLink.vue?vue&type=template&id=20f248f2"
import script from "./KLink.vue?vue&type=script&setup=true&lang=js"
export * from "./KLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports